/* @sravni/react-design-system version 0.2.50 */
import { __extends, __spreadArray, __read } from 'tslib';
import { EventEmitter } from 'events';
import { getUuid } from '@sravni/react-utils';

var STATUSES = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
};
var TIMEOUT = 15000;
var NotificationManager = /** @class */ (function (_super) {
    __extends(NotificationManager, _super);
    function NotificationManager() {
        var _this = _super.call(this) || this;
        _this.notifications = [];
        return _this;
    }
    NotificationManager.prototype.create = function (_a) {
        var _this = this;
        var _b = _a.type, type = _b === void 0 ? 'info' : _b, title = _a.title, subtitle = _a.subtitle, message = _a.message, timeout = _a.timeout;
        var opts = {
            id: getUuid(),
            type: type,
            title: title,
            subtitle: subtitle,
            message: message,
        };
        this.notifications.unshift(opts);
        this.emitChange();
        setTimeout(function () {
            _this.remove(opts.id);
        }, timeout);
    };
    // info(title: string, subtitle: string, message: string) {
    //   this.create({
    //     type: STATUSES.INFO,
    //     title,
    //     subtitle,
    //     message,
    //   })
    // }
    //
    // success(title: string, subtitle: string, message: string) {
    //   this.create({
    //     type: STATUSES.SUCCESS,
    //     title,
    //     subtitle,
    //     message,
    //   })
    // }
    //
    // warning(title: string, subtitle: string, message: string) {
    //   this.create({
    //     type: STATUSES.WARNING,
    //     title,
    //     subtitle,
    //     message,
    //   })
    // }
    //
    // error(title: string, subtitle: string, message: string) {
    //   this.create({
    //     type: STATUSES.ERROR,
    //     title,
    //     subtitle,
    //     message,
    //   })
    // }
    NotificationManager.prototype.show = function (title, subtitle, message, timeout) {
        if (timeout === void 0) { timeout = TIMEOUT; }
        this.create({
            type: STATUSES.INFO,
            title: title,
            subtitle: subtitle,
            message: message,
            timeout: timeout,
        });
    };
    NotificationManager.prototype.remove = function (id) {
        this.notifications = this.notifications.filter(function (n) { return id !== n.id; });
        this.emitChange();
    };
    NotificationManager.prototype.emitChange = function () {
        this.emit('change', __spreadArray([], __read(this.notifications)));
    };
    NotificationManager.prototype.addChangeListener = function (callback) {
        this.addListener('change', callback);
    };
    NotificationManager.prototype.removeChangeListener = function (callback) {
        this.removeListener('change', callback);
    };
    return NotificationManager;
}(EventEmitter));
var NotificationManager$1 = new NotificationManager();

export default NotificationManager$1;
//# sourceMappingURL=NotificationManager.js.map
